/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState } from 'react';
import { ResponsiveTable, Label, Icon } from '@fitinsur/components';
import * as S from './styles';

function RenderProfileList({formik, listData, setRolesGroup, isBound, getDescription, idGroup}) {
    
    const [showRoleItem, setShowRoleItens] = useState([]);
    
    const handleShowRoleItem = (listItemIndex, show) => {
        if (show) {
            setShowRoleItens((prev) => [...prev, listItemIndex])
        } else {
            setShowRoleItens((prev) => [...prev.filter((item) => item !== listItemIndex )])        
        }
    }

    const removeItem = (listItem) => {
        if (listItem?.idGroupMembership) {
            setRolesGroup((prev) => prev.map((item) => {
                if (item.idRole === listItem.idRole) {
                    item.isExpired = true;
                }
                return item;
            }))
            return;
        }

        setRolesGroup((prev) => prev.filter((item) => item.idRole !== listItem.idRole))
    }

    const columns = [
        {
          title: getDescription("DOMAINS", 868) || "lista DE PERFIS", //"LISTA DE PERFIS"
          value: "roleName",
          minWidth: 30,
          maxWidth:50,
          component: (listItem, index) => {
            return (
              <>
                <Label wordWrap fontSize={13}>
                        {listItem?.accessRoleItem?.length >= 1 &&
                            (showRoleItem.includes(index)
                                ? (
                                    <Icon
                                        name={"arrowup"}
                                        onClick={() => handleShowRoleItem(index, false)}
                                    />
                                )
                                : (
                                    <Icon
                                        name={"arrowdown"}
                                        onClick={() => handleShowRoleItem(index, true)}
                                    />
                                )
                            )
                        }
                        {"  "}
                  {listItem.roleName || listItem.domainDescription}
                </Label>
              </>
            );
          },
        },
        {
            title:getDescription("DOMAIN",869) || "GRUPO DE ORIGEM", //"GRUPO DE ORIGEM",
            value: "groupParentName",
            minWidth: 60,
            notLastColumnAlign: true,
            component: (listItem) => <S.RowWrapper>
                <Label>{listItem.groupParentName}</Label><br/>
                {(!listItem.idRoleItem && !(listItem.idGroup && listItem.idGroup != idGroup) && !isBound) && <Icon name="trash" onClick={() => removeItem(listItem)} />}
            </S.RowWrapper>
        },
      ];

    return (
        < ResponsiveTable
            //onSortTable={handleSortList}
            //showEndorsement={handleShowRoleItem}
            formikRef={formik?.current}
            columns={columns}
            data={listData.filter(item => !(item.isExpired))}
            showChildren={showRoleItem}
            childrenKey="accessRoleItem"
        />
    )

}

const components = {
    RenderProfileList,
}

export { components }